import React, { useState } from 'react'
import { Box } from '@mui/material'
import { Button, makeStyles } from '@material-ui/core'
import { MOTOR_POLICY_EXPIRE_DETAILS } from 'src/utils/constants/BuyPolicyMotor'
import { useDispatch, useSelector } from 'react-redux'
import { updatePreviousPolicyDetailsMotor } from 'src/actions'
import CustomDatePicker from 'src/components/BuyPolicy/common/CustomDatePicker'

const PolicyExpireDetailsTile = ({ handleCloseEditPopover }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const previousPolicyDetails = motorDetails?.previousPolicyDetails

  const [policyExpireData, setPolicyExpireData] = useState(
    previousPolicyDetails?.isPolicyExpired
  )
  const [policyExpiryDate, setPolicyExpiryDate] = useState(
    previousPolicyDetails?.expiryDate
  )
  const [policyExpiredDate, setPolicyExpiredDate] = useState(
    previousPolicyDetails?.expiredDate
  )

  const handlePolicyExpireChange = async (event) => {
    if (policyExpireData === MOTOR_POLICY_EXPIRE_DETAILS?.NotExpired) {
      setPolicyExpiryDate(event?.target?.value)
      setPolicyExpiredDate('')
    } else {
      setPolicyExpiredDate(event?.target?.value)
      setPolicyExpiryDate('')
    }
  }

  const handleExpireDetailsSubmit = () => {
    dispatch(
      updatePreviousPolicyDetailsMotor({
        ...previousPolicyDetails,
        isPolicyExpired: policyExpireData,
        expiredDate: policyExpiredDate,
        expiryDate: policyExpiryDate,
      })
    )
    handleCloseEditPopover()
  }

  return (
    <Box className={classes.policyExpireDetailsContainer}>
      <Box className={classes.switchContainer}>
        <Box className={classes.switchContainerMain}>
          <Box
            className={`${classes.policyCategoryContainer} ${
              policyExpireData === MOTOR_POLICY_EXPIRE_DETAILS?.NotExpired
                ? classes.selected
                : classes.notSelected
            }`}
            onClick={() =>
              setPolicyExpireData(MOTOR_POLICY_EXPIRE_DETAILS?.NotExpired)
            }
            id='notExpired-policy'
          >
            <Box className={classes.policyNotExpiredText}>Not Expired</Box>
          </Box>

          <Box
            className={`${classes.policyCategoryContainer} ${
              policyExpireData === MOTOR_POLICY_EXPIRE_DETAILS?.Expired
                ? classes.selected
                : classes.notSelected
            }`}
            onClick={() =>
              setPolicyExpireData(MOTOR_POLICY_EXPIRE_DETAILS?.Expired)
            }
            id='expired-policy'
          >
            <Box className={classes.policyExpiredText}>Expired</Box>
          </Box>
        </Box>
      </Box>
      <Box>
        {/* <TextField
          id='policy-expiry'
          name='expireDate'
          type='date'
        
          
          InputLabelProps={{
            shrink: true,
          }}
          size='small'
        /> */}
        <CustomDatePicker
          id='policy-expiry'
          name='expireDate'
          placeholder='Policy Expiry Date *'
          value={
            (policyExpireData === MOTOR_POLICY_EXPIRE_DETAILS?.Expired &&
              policyExpiredDate) ||
            (policyExpireData === MOTOR_POLICY_EXPIRE_DETAILS?.NotExpired &&
              policyExpiryDate)
          }
          onChange={handlePolicyExpireChange}
          className={classes.expiryDatepicker}
        />
      </Box>
      <Button
        className={classes.expireDetailBtn}
        onClick={handleExpireDetailsSubmit}
      >
        Set this Values
      </Button>
    </Box>
  )
}

export default PolicyExpireDetailsTile

const useStyles = makeStyles({
  policyExpireDetailsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10,
    background: '#FFFFFF',
    boxShadow: '0px 0px 15px 0px #00000066',
    padding: 20,
    flexDirection: 'column',
    gap: 10,
  },
  switchContainer: {
    border: '1px solid #C1C1C1',
    backgroundColor: '#FFFFFF',
    borderRadius: 5,
    maxWidth: '290px',
  },
  switchContainerMain: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '3px',
    padding: '4px',
  },
  expiryDatepicker: {
    '&  .MuiOutlinedInput-input': {
      height: '0.3rem',
    },
  },
  policyCategoryContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
    padding: '0px 10px 0px 10px',
    cursor: 'pointer',
    height: '25px',
    color: '#2BA6C8',
  },

  policyNotExpiredText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16.41px',
  },
  policyExpiredText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16.41px',
  },
  selected: {
    background: '#29BDE4',
    borderRadius: 3,
    color: '#FFFFFF',
  },
  notSelected: {
    color: '#A4A4A4',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    minWidth: 60,
  },
  expireDetailBtn: {
    color: '#FFFFFF',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '14.06px',
    background: 'linear-gradient(87.86deg, #59ADCA -1.42%, #60B9E0 154.94%)',
    maxWidth: '131px',
    maxHeight: '35px',
  },
})
